import React, {useEffect} from 'react'

import type {Margin} from '../../../model'
import {useMapRef} from '../lib'

const DEFAULT_MARGIN: Margin = [0, 0, 0, 0]

/**
 * компонент для того, чтобы margin имел динамическое поведение
 */
const MapMarginBase = ({margin}: {margin?: Margin}) => {
  const map = useMapRef()
  useEffect(() => {
    if (map) {
      const {zoom} = map
      map.setMargin(margin || DEFAULT_MARGIN)
      map.setLocation({zoom})
    }
  }, [map, margin])
  return null
}

export const MapMargin = React.memo(MapMarginBase)
